<div class="routed-container">
  <div
    class="routed-content justify-center items-center flex flex-col w-full"
    #routedContainer
  >
    <div class="flex gap-2 items-center w-100">
      <a
        [routerLink]="['/employees']"
        class="back-button flex items-center justify-center gap-2 no-decoration"
      >
        <i class="material-icons">arrow_back</i>
        <span>Back</span>
      </a>
      <h2 class="w-70 center-text">Add New Client</h2>
    </div>
    <form class="w-100" #form="ngForm" (ngSubmit)="saveClient(form)">
      <div class="flex gap-2 w-100">
        <div class="input-group">
          <label for="fn"
            >Client Name <span class="required-indicator">*</span></label
          >
          <input
            type="text"
            [(ngModel)]="newClient.client_name"
            id="fn"
            required
            name="client_name"
            class="textbox p-10"
          />
          <div *ngIf="form.submitted && form.controls.client_name?.invalid" class="pt-10">
            <small class="error-message">Client Name is required</small>
          </div>
        </div>

        <div class="input-group">
          <label for="ln" class="pb-10">Company Name</label>
          <input
            type="text"
            [(ngModel)]="newClient.company_name"
            id="ln"
            required
            name="company_name"
            class="textbox p-10"
          />
        </div>
      </div>

      <div class="input-group">
        <label for="status">Billing Frequency</label>
        <select
          class="textbox p-10"
          id="status"
          [(ngModel)]="newClient.billing_frequency"
        >
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="net30">Net 30</option>
        </select>
      </div>

      <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>
      <p *ngIf="successMessage" class="success-message">{{ successMessage }}</p>
      <button type="submit" class="back-button w-100 save-button">
                {{ isSaving ? 'Saving...': 'Save Client' }}
            </button>
    </form>
  </div>
</div>
